module.exports = __webpack_public_path__ + "media/images/PRP_Splash_Page_Logo-0fe0b12e6d371bb38e101a0cc9c6c2ac.png";